import { toast } from 'sonner'

/** Accept legacy (enqueueSnackbar, message) or (message). */
function resolveMessage(a, b) {
  if (b !== undefined) return b
  return a
}

/**
 * Error toast — legacy enqueueSnackbar arg ignored.
 * Call: showErrorSnackbar(message) or showErrorSnackbar(_, message)
 */
export default function showErrorSnackbar(a, b) {
  const message = resolveMessage(a, b)
  if (!message) return
  toast.error(String(message), { duration: 4500 })
}
